import React from 'react'
import {
  ImageView,
  styled,
  Box,
  BoxProps,
  ImageViewProps,
} from '../../design-system'

const ProfilePicImage = styled(ImageView)`
  filter: grayscale(100%);
  user-select: none;
`

const ProfilePicTone = styled.div`
  background: linear-gradient(0deg, #5f4a4f, #5f4a4f);
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  mix-blend-mode: screen;
  z-index: 1;
`

const ProfilePicGradient = styled.div`
  background: linear-gradient(
    180deg,
    rgba(35, 31, 32, 0.47) 0%,
    rgba(255, 255, 255, 0) 100%
  );
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 1;
`

interface ProfilePicProps extends BoxProps, ImageViewProps {}

export const ProfilePicture = ({
  src,
  objectFit = 'cover',
  ...boxProps
}: ProfilePicProps) => (
  <Box {...boxProps}>
    <ProfilePicImage
      draggable={false}
      width="100%"
      height="100%"
      objectFit={objectFit}
      src={src}
    />
    <ProfilePicGradient />
    <ProfilePicTone />
  </Box>
)
